export { highlightText, createTag } from './textUtils';
